import React, { useEffect, useState } from 'react'
import { adminRequest, mediaUrl } from '../api/client'
import { BackLink, DetailGrid, SummaryGrid } from '../components/AdminCommon'
import AdminHtmlPreview from '../components/AdminHtmlPreview'
import { Card, EmptyState, PageTitle, StatusBadge, formatDate } from '../components/Ui'

function safePublicCode(rows, id) {
  return (rows || []).find((row) => row.id === id)?.publicCode || null
}

export default function StoryDetailLive({ id, navigate }) {
  const [item, setItem] = useState(null)
  const [publicCode, setPublicCode] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    let disposed = false
    setLoading(true); setError('')
    Promise.all([
      adminRequest(`/api/v1/admin/stories/${encodeURIComponent(id)}`),
      adminRequest('/api/v1/stories').catch(() => ({ data: [] }))
    ]).then(([detail, publicRows]) => {
      if (disposed) return
      const story = detail?.data || null
      setItem(story)
      setPublicCode(safePublicCode(publicRows?.data, story?.id))
    }).catch((nextError) => {
      if (!disposed) setError(nextError?.message || '디팬 이야기를 불러오지 못했습니다.')
    }).finally(() => { if (!disposed) setLoading(false) })
    return () => { disposed = true }
  }, [id])

  if (loading) return <><BackLink onClick={() => navigate('/content/stories')} /><Card><p>실제 stories 원장을 조회하는 중입니다.</p></Card></>
  if (error || !item) return <><BackLink onClick={() => navigate('/content/stories')} /><Card><EmptyState title="디팬 이야기 조회 실패" description={error || '콘텐츠를 찾을 수 없습니다.'} /></Card></>

  const previewCode = publicCode || item.id
  const thumbnail = mediaUrl(item.thumbnailMediaId)
  const cover = mediaUrl(item.coverMediaId || item.thumbnailMediaId)
  return <>
    <BackLink onClick={() => navigate('/content/stories')} />
    <PageTitle eyebrow="DIFAN STORY · LIVE DB" title={item.title} description="관리자와 사용자 화면이 동일한 stories 행과 media_assets를 조회하는 상세 화면입니다." actions={<><button className="button soft" onClick={() => navigate('/content/stories')}>목록·수정</button>{item.status === 'PUBLISHED' && <button className="button primary" onClick={() => window.open(`https://difan.co.kr/stories/${previewCode}`, '_blank', 'noopener,noreferrer')}>사용자 상세 보기</button>}</>} />
    <SummaryGrid items={[
      { label:'상태', value:<StatusBadge status={item.status} /> },
      { label:'외부 표시 ID', value:<span className="mono">{publicCode || '공개 상태에서 확인'}</span> },
      { label:'카테고리', value:item.category || '-' },
      { label:'조회수', value:Number(item.viewCount || 0).toLocaleString('ko-KR') }
    ]} />
    <div className="dashboard-grid half">
      <Card title="스토리 원장"><DetailGrid items={[
        { label:'내부 UUID', value:item.id, wide:true },
        { label:'Slug', value:item.slug || '-' },
        { label:'작성자', value:item.author || '-' },
        { label:'읽기 시간', value:`${Number(item.readMinutes || 5)}분` },
        { label:'추천', value:item.isFeatured ? '예' : '아니오' },
        { label:'발행일', value:item.publishedAt ? formatDate(item.publishedAt, true) : '-' },
        { label:'수정일', value:formatDate(item.updatedAt, true) },
        { label:'Version', value:`v${item.version}` },
        { label:'요약', value:item.excerpt || '-', wide:true },
        { label:'태그', value:Array.isArray(item.tags) && item.tags.length ? item.tags.join(', ') : '-', wide:true }
      ]} /></Card>
      <Card title="실제 미디어 연결"><div className="admin-detail-stack"><div><span>thumbnail_media_id</span><strong className="mono">{item.thumbnailMediaId || '-'}</strong></div><div><span>cover_media_id</span><strong className="mono">{item.coverMediaId || item.thumbnailMediaId || '-'}</strong></div></div>{thumbnail ? <div className="admin-upload-preview" style={{marginTop:16}}><img src={thumbnail} alt={`${item.title} 썸네일`} /></div> : <EmptyState title="썸네일 미등록" />}{cover && cover !== thumbnail ? <div className="admin-upload-preview" style={{marginTop:12}}><img src={cover} alt={`${item.title} 대표 이미지`} /></div> : null}</Card>
    </div>
    <Card title="본문"><AdminHtmlPreview title="디팬 이야기 본문 미리보기" bodyHtml={item.bodyHtml} /></Card>
    <Card title="관리자 ↔ 사용자 동일 행 검증"><DetailGrid items={[{ label:'관리자 조회 UUID', value:item.id, wide:true },{ label:'사용자 URL', value:`/stories/${previewCode}`, wide:true },{ label:'미디어 전달 방식', value:'stories.thumbnail_media_id / cover_media_id → media_assets.storage_key → NCP Object Storage → /api/v1/media/:id/content', wide:true }]} /></Card>
  </>
}
